<template>
    <button>
        <span>{{text}}</span>
        <img src="@/assets/PlusGreen.svg"/>
    </button>
</template>

<script>
    export default {
        name: "AddButtonGreen",
        props:{
            text:{
               type: String,
               default:''
            },
            setup(){
            }

        }
    }
</script>

<style scoped>

</style>
